<template>
  <v-container>
   <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-btn
        slot="activator"
        color="red lighten-2"
        dark
      >
        Click Me
      </v-btn>

      <v-card class="card-pop">

    <v-layout align-center justify-center row fill-height>
      <v-flex>
         <div class="resultContainer width">
            <div class=" text-xs-center" align-center >

            <v-flex xs12 class="p-colors mt-5 " >
                <div class="div-cricle center">
               <v-icon class="mb-2 icon-size">fas fa-check-circle</v-icon>
              </div>
            </v-flex>
            <v-flex xs12 class="mb-3">
             <span class="choose-package ">Go To Bookings</span>

            </v-flex>
            </div>
        </div>
      </v-flex>
    </v-layout>
    </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  /* eslint-disable */
  export default {
  name: "AddCustomerSuccess",
  };
</script>
<style >
.choose-package{
  font-size: 15px;
  font-weight: 700;
  color: #0051a0;
}

.div-cricle{
 text-align: center;
 margin-top: 0%;
 z-index: 500;
 background-color: transparent !important;
}
.v-dialog{
  box-shadow: none !important;
}
.icon-size{
  font-size: 100px;
  color: #0051a0 !important;
  height: 100px;
  width: 100px;
  border-radius: 50%;

}

  .font-size-cus{
    font-size: 50px;
    padding:20px;
    font-weight: 100;
    width: 50%;
    height: 50%;
  }


</style>



// WEBPACK FOOTER //
// src/components/pages/sasee/GoToBooking.vue